import {
  GET_VIDEO_CONTENT_ITEM,
  SET_ORDER_BY,
  SET_SORT_BY,
  SET_PAGE,
  SET_SEARCH,
  SET_PRODUCT_ID,
} from "../../shared/constants/ActionTypes";

const initialVideoContentItem = {
  eh_videoItem: [],
  videoItemCount: 0,
  page: 1,
  search: "",
  courseId: "",
  sortby: "",
  orderby: "desc",
};

const videoContentItemReducer = (state = initialVideoContentItem, action) => {
  switch (action.type) {
    case GET_VIDEO_CONTENT_ITEM:
      return {
        ...state,
        eh_videoItem: action.payload.items,

        videoItemCount: action.payload.totalCount,
      };
    case SET_PAGE:
      return {
        ...state,
        page: action.payload,
      };

    case SET_SEARCH:
      return {
        ...state,
        search: action.payload,
      };
    case SET_PRODUCT_ID:
      return {
        ...state,
        courseId: action.payload,
      };
    case SET_ORDER_BY:
      return {
        ...state,
        orderby: action.payload,
      };
    case SET_SORT_BY:
      return {
        ...state,
        sortby: action.payload,
      };
    default:
      return state;
  }
};

export default videoContentItemReducer;
